import { Typography, Paper } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import React from 'react';
import { translate } from 'react-i18next';
import classNames from 'classnames';

import { callValuation } from '../../services/transfersService';
import { Button } from 'material-ui';
import { Grid } from 'material-ui';
import PriceTag from './../Results/PriceTag';
import { CircularProgress } from 'material-ui';
import DynIcon from '../Utils/DynIcon';


const styles = theme => ({
    root: {
        marginBottom: 20,
        padding: 10,
        '&:hover': {
            backgroundColor: 'ghostwhite',
        },
    },
    blue: {
        color: theme.palette.primary.main,
    },
    wrapper: {
        margin: 0,
        position: 'relative',
    },
    buttonSuccess: {
        backgroundColor: 'green',
        '&:hover': {
            backgroundColor: 'green',
        },
    },
    buttonProgress: {
        color: 'ligth-green',
        position: 'absolute',
        top: '50%',
        /* left: '50%', */
        marginTop: -12,
        marginLeft: -60,
    },
    roundtripOriginDesc: {
        float: 'right',
        position: 'relative',
        right: '200px',
        paddingRight: '70px'
    },
    onewayOriginDesc: {
        float: 'right',
        position: 'relative',
        paddingLeft: '70px'
    }

});

class TransferCardRender extends React.Component {

    constructor(props) {
        super(props);
        this.state = { loading: false };
    }

    submit = () => {
        const { transfer, token } = this.props;

        const availResponse = JSON.parse(localStorage.getItem(token));
        transfer.reqFrom = availResponse.from;
        transfer.reqTo = availResponse.to;

        this.setState({ loading: true, inputError: false });
        callValuation(transfer).then(data => {
            let newurl = window.location.href.replace('results/', '');
            window.location.href = newurl + '/valuation/' + data.requestToken;
        }).catch(e => {
            alert(e.message + '\n' + (e.detailedMessage || ''));
            this.setState({ loading: false, inputError: '<b>' + e.message + '</b><br />' + e.detailedMessage });
        }).then(() => {
            this.setState({ loading: false });
        });
    }

    render() {
        const { classes, transfer, t /* , user */ } = this.props;
        const buttonClassname = classNames({
            [classes.buttonSuccess]: this.state.success,
        });
        return (
            <Paper elevation="2" className={classes.root}>
                <Grid container>
                    <Grid item xs={2}>
                        <img src={transfer.image} alt="cab logo" width="200px" />
                    </Grid>
                    <Grid item xs={10}>
                        <Typography title={transfer.name} variant="headline">{transfer.name}</Typography>
                        <table border={0} style={{ width: '100%', marginTop: '10px' }}>
                            {/** TRANSFER FROM */}
                            <tr>
                                <td style={{ paddingBottom: '16px' }}>
                                    <Typography>
                                        {transfer.transferName ? '' : <DynIcon icon="LocationOn" />}
                                        <b className={classes.blue}>{t('TRANSFERS.FROM')}: </b>
                                        <b>{transfer.transferName ? <span>{transfer.transferName}<br /></span> : ''}</b>
                                        {transfer.transferName ? <DynIcon icon="LocationOn" /> : ''}
                                        <span>{transfer.originName} <b style={{ fontSize: '22px', fontWeight: 'bolder' }}>&rarr;</b> {transfer.destinationName}</span>
                                    </Typography>
                                    {
                                        transfer.searchDataFrom.type.id === 'MTP' ?
                                            <Typography style={{ margin: '4px' }}>
                                                <span className={classes.blue}>
                                                    {t('TRANSFERS.FROM_MTP')}:
                                                </span>&nbsp;
                                                <span>{transfer.searchDataFrom.formattedName}</span>
                                            </Typography>
                                            : ''
                                    }
                                    {
                                        transfer.searchDataTo.type.id === 'MTP' ?
                                            <Typography style={{ margin: '4px' }}>
                                                <span className={classes.blue}>
                                                    {t('TRANSFERS.TO_MTP')}:
                                                </span>&nbsp;
                                                <span>{transfer.searchDataTo.formattedName}</span>
                                            </Typography>
                                            : ''
                                    }
                                </td>
                                <td style={{ verticalAlign: 'top', width: '32px' }}>{transfer.originDescription ?
                                    <Typography title={transfer.originDescription}>
                                        <DynIcon icon="Info" style={{ color: 'green' }} />
                                    </Typography> :
                                    ''}
                                </td>
                                <td style={{ verticalAlign: 'top' }}>
                                    {t('TRANSFERS.DATE_FROM')}
                                </td>
                                <td style={{ verticalAlign: 'top', width: '120px' }}>
                                    <DynIcon icon="Event" />{transfer.dateTime}
                                </td>
                                <td rowspan={transfer.to ? '2' : '1'} style={{ textAlign: 'right', verticalAlign: 'top', width: '220px' }}>
                                    <PriceTag pvp={transfer.pvp} price={transfer.price} showNetPrice="true" B2bVerPVP="true" />
                                    <Typography>{t(`TRANSFERS.${transfer.typeDescription}`)}</Typography>
                                    <Typography style={{ color: 'grey' }}>{t('TRANSFERS.BEST_PRICE')}</Typography>
                                </td>
                            </tr>
                            {/** TRANSFER TO */}
                            {transfer.to ?
                                <tr>
                                    <td>
                                        <Typography>
                                            {transfer.to.transferName ? '' : <DynIcon icon="LocationOn" />}
                                            <b className={classes.blue}>{t('TRANSFERS.TO')}: </b>
                                            <b>{transfer.to.transferName ? <span>{transfer.to.transferName}<br /></span> : ''}</b>
                                            {transfer.to.transferName ? <DynIcon icon="LocationOn" /> : ''}
                                            <span> {transfer.to.originName} <b style={{ fontSize: '22px', fontWeight: 'bolder' }}>&rarr;</b> {transfer.to.destinationName}</span>
                                        </Typography>
                                        {
                                            transfer.searchDataTo.type.id === 'MTP' ?
                                                <Typography style={{ margin: '4px' }}>
                                                    <span className={classes.blue}>
                                                        {t('TRANSFERS.FROM_MTP')}:
                                                    </span>&nbsp;
                                                    <span>{transfer.searchDataTo.formattedName}</span>
                                                </Typography>
                                                : ''
                                        }
                                        {
                                            transfer.searchDataFrom.type.id === 'MTP' ?
                                                <Typography style={{ margin: '4px' }}>
                                                    <span className={classes.blue}>
                                                        {t('TRANSFERS.TO_MTP')}:
                                                    </span>&nbsp;
                                                    <span>{transfer.searchDataFrom.formattedName}</span>
                                                </Typography>
                                                : ''
                                        }
                                    </td>
                                    <td style={{ verticalAlign: 'top' }}>{transfer.destinationDescription ?
                                        <div title={transfer.destinationDescription}>
                                            <DynIcon icon="Info" style={{ color: 'green' }} />
                                        </div>
                                        : ''
                                    }</td>
                                    <td style={{ verticalAlign: 'top' }}>
                                        {t('TRANSFERS.DATE_TO')}
                                    </td>
                                    <td style={{ verticalAlign: 'top' }}><DynIcon icon="Event" /> {transfer.to.dateTime}</td>
                                </tr> :
                                ''}
                            <tr>
                                <td style={{ textAlign: 'right', verticalAlign: 'top' }} colSpan="5">
                                    <div className={classes.wrapper}>
                                        <Button
                                            variant="raised" color="primary"
                                            className={buttonClassname}
                                            disabled={this.state.loading}
                                            onClick={this.submit}>{t('COMMON.RESERVE')}
                                        </Button>
                                        {
                                            this.state.loading &&
                                            <CircularProgress
                                                size={24}
                                                className={classes.buttonProgress}
                                            />
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="5">
                                    <Typography dangerouslySetInnerHTML={{
                                        __html:
                                            transfer.description ? transfer.description.split('\n').join('<br />') : ''
                                    }}></Typography>
                                </td>
                            </tr>
                        </table>
                    </Grid>
                </Grid>
            </Paper >
        );
    }
}

export default translate('translations')(withStyles(styles)(TransferCardRender));


// WEBPACK FOOTER //
// ./src/components/Transfers/TransferCardRender.js